import { KYMW1404Component } from './kymw1404.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import * as wjcCore from '@grapecity/wijmo';

/**
 * 掲載候補商品リスト画面の値を管理するクラス
 *
 * @export KYMW1404Model
 * @class KYMW1404Model
 */
export class KYMW1404Model {

  kymw1404Component: KYMW1404Component;

  // 売り場のリスト選択値
  public sellingArea: string;

  /* ********** KYMW1404:掲載候補商品リスト ********** */
  // 検索結果
  /**
   * 売り場コンボボックス用Array<any>
   */
  public sellingAreaArray: Array<any> = null;

  /**
   * 検索結果格納用Array<any>
   */
  public nominationGoodsArray: Array<any> = null;

  // 検索条件
  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   *  ページ番号
   */
  public pageNum = String('');

  /**
   *  売り場コード
   */
  public sellAreaCode = String('');

  /**
   * 部門コード
   */
  public classCode = String('');

  public orderNumQuota = String('');
  public orderNumQuotaIdx = Number(0);

  /**
   * Ｗ掲載予定のみフラグ
   */
  public wPubilshFlg = Number(0);

  /**
   * 未掲載候補のみフラグ
   */
  public notPublishFlg = Number(1);


  /**
   * ソート指定項目
   */
  public sortItem = String('');

  /**
   * 昇順降順
   */
  public sortOrder = String('');

  /**
   * 取得対象ページ(表示中のページ)
   */
  public page = Number(1);

  /**
   *  注文商品区分
   */
  public orderGoodsFlg = String('01');

  // データ保持用
  /**
   * 売り場のリスト：元データ
   */
  public cmbSellingAreaList: Array<any> = new Array<any>();

  /**
   * 部門コード(コンボボックス)のリスト
   */
  public cmbClassCodeList: Array<any> = new Array<any>();

  /**
   *  処理区分
   */
  public processDiv: number = null;

  /**
   *  編集モード
   */
  public editMode = String('');

  /**
   *  アクティブコマ有無フラグ
   */
  public activeKomaFlag: number = null;

  /**
   * コマ割画面への貼り付け件数
   * 再検索時の表示ページ判定で使用
   */
  public pasteCnt = Number(0);

  /**
   * 一覧の表示件数
   * 再検索時の表示ページ判定で使用
   */
  public listCnt = Number(0);

  /**
   * 注文商品区分(コンボボックス)のリスト
   */
  public cmbOrderGoodsFlgList: Array<any> = new Array<any>();

  /**
   * 注文商品区分コンボボックス用Array<any>
   */
  public orderGoodsFlgArray: Array<any> = null;

  /* ********** KYMW1405:掲載候補商品検索 ********** */
  /**
   * 部門コード配列(チェックありのデータ)
   */
  public classCodeArray: Array<any> = new Array<any>();

  /**
   * 商品案内用商品名
   */
  public guideGoodsName = String('');

  /**
   * Ｐコードリスト
   */
  public pcodeList: string[] = [];

  /**
   * 他媒体対象フラグ
   */
  public otherMediumTypeFlg = Number(0);

  /**
   * スクロールバーポジション
   */
  public verticalScrollPosition = Number(0);

  public searchValueChangeFlag = Boolean(false);
  public showFirstOrderNumCombo = Boolean(true);

  /**
   *  業態区分
   */
  public dutiesFormDiv = String('1');

  /**
   * 業態区分デイリーArray<any>
   */
  public dutiesFormDailyList: Array<any> = new Array<any>();

  public chkWPublish = Boolean(false);
  public chkNotPublish = Boolean(true);

  public disabledSellAreaName = Boolean(false);
  public disabledWPublishFlg = Boolean(false);
  public disabledOrderNumQuota = Boolean(false);
  public disabledOrderGoodsFlg = Boolean(false);

  public disabledPreviousButton = Boolean(true);
  public disabledNextButton = Boolean(true);

  public orderCodeOrderNumQuota = String('');
  public mediumTypeOrderNumQuota = String('');

  /**
   * グリッドのフィルタ状態
   */
  public filterStatus = String('');
  /**
   * グリッドのソート状態
   */
  public sortStatus: any;

  /**
   * 売り場コンボボックスを生成
   * @param serverData サーバからの受信データ
   *
   */
  public setSellingAreaList(serverData: any): void {
    if (serverData == null) {
      this.cmbSellingAreaList = new Array<any>();
    } else {
      if (serverData instanceof Object) {
        this.cmbSellingAreaList = serverData;
      } else {
        this.cmbSellingAreaList = new Array<any>();
      }
    }

    const showArray: Array<any> = new Array<any>();

    // 先頭の空白行を設定
    showArray.push('');
    // コード+：+名称追加
    for (let index = Number(0); index < this.cmbSellingAreaList.length; index++) {
      showArray.push(this.cmbSellingAreaList[index].SellAreaCode + ':' + this.cmbSellingAreaList[index].SellAreaName);
    }

    this.sellingAreaArray = showArray;
  }

  /**
   * 掲載候補商品リストの結果を表示する
   * @param serverData サーバからの受信データ
   *
   */
  public updateServerResponse(serverData: any): void {
    // 作業用変数定義
    const nominationList: Array<any> = new Array<any>();

    // 検索結果の格納を行う
    if (serverData.NominationGoodsData != null) {
      for (let i = Number(0); i < serverData.NominationGoodsData.length; i++) {
        const obj: any = new Object();
        obj.Arranged = this.nullTOEmpty(serverData.NominationGoodsData[i].Arranged);
        obj.WPublish = this.nullTOEmpty(serverData.NominationGoodsData[i].WPublish);
        obj.OrderCodeDiff = this.nullTOEmpty(serverData.NominationGoodsData[i].OrderCodeDiff);
        obj.GuideGoodsName = this.nullTOEmpty(serverData.NominationGoodsData[i].GuideGoodsName);
        obj.GuideStandardName = this.nullTOEmpty(serverData.NominationGoodsData[i].GuideStandardName);
        obj.ClassName = this.nullTOEmpty(serverData.NominationGoodsData[i].ClassName);
        obj.MiddleClassName = this.nullTOEmpty(serverData.NominationGoodsData[i].MiddleClassName);
        obj.SmallClassName = this.nullTOEmpty(serverData.NominationGoodsData[i].SmallClassName);
        obj.GuideTempZoneName = this.nullTOEmpty(serverData.NominationGoodsData[i].GuideTempZoneName);
        obj.PlanNum = this.nullTOEmpty(serverData.NominationGoodsData[i].PlanNum) === '' ? '' :
          Number(serverData.NominationGoodsData[i].PlanNum);
        obj.PlanPrice = this.nullTOEmpty(serverData.NominationGoodsData[i].PlanPrice) === '' ? '' : 
          Number(serverData.NominationGoodsData[i].PlanPrice);
        obj.Gpr = PlessViewUtilsSub.nullToBlank(serverData.NominationGoodsData[i].Gpr) === '' ? '' :
          Number(serverData.NominationGoodsData[i].Gpr);
        obj.Pcode = this.nullTOEmpty(serverData.NominationGoodsData[i].PCode);
        obj.PricePattern = this.nullTOEmpty(serverData.NominationGoodsData[i].PricePattern);
        obj.BuyerComment = this.nullTOEmpty(serverData.NominationGoodsData[i].BuyerComment);
        obj.RelateMasterCode = this.nullTOEmpty(serverData.NominationGoodsData[i].RelateMasterCode);
        obj.EnableIbaraki = this.nullTOEmpty(serverData.NominationGoodsData[i].EnableIbaraki);
        obj.EnableTochigi = this.nullTOEmpty(serverData.NominationGoodsData[i].EnableTochigi);
        obj.EnableGunma = this.nullTOEmpty(serverData.NominationGoodsData[i].EnableGunma);
        obj.EnableChiba = this.nullTOEmpty(serverData.NominationGoodsData[i].EnableChiba);
        obj.EnableSaitama = this.nullTOEmpty(serverData.NominationGoodsData[i].EnableSaitama);
        obj.EnableTokyo = this.nullTOEmpty(serverData.NominationGoodsData[i].EnableTokyo);
        obj.EnableNagano = this.nullTOEmpty(serverData.NominationGoodsData[i].EnableNagano);
        obj.EnableNiigata = this.nullTOEmpty(serverData.NominationGoodsData[i].EnableNiigata);
        obj.OtherMediumTypeFlg = this.nullTOEmpty(serverData.NominationGoodsData[i].OtherMediumTypeFlg);
        obj.PublishCnt = this.nullTOEmpty(serverData.NominationGoodsData[i].PublishCnt);
        obj.ParentCnt = this.nullTOEmpty(serverData.NominationGoodsData[i].ParentCnt);
        obj.MarkCode = this.nullTOEmpty(serverData.NominationGoodsData[i].MarkCode);
        obj.ThisTimeSupplyPrice = this.nullTOEmpty(serverData.NominationGoodsData[i].ThisTimeSupplyPrice) === '' ? '' :
          Number(serverData.NominationGoodsData[i].ThisTimeSupplyPrice);
        obj.OrderNum = this.nullTOEmpty(serverData.NominationGoodsData[i].OrderNum);
        obj.ReceiptSOrderCode = this.nullTOEmpty(serverData.NominationGoodsData[i].ReceiptSOrderCode);
        obj.StartOrderCode = this.nullTOEmpty(serverData.NominationGoodsData[i].StartOrderCode);
        obj.OrderNum6Digits = this.nullTOEmpty(serverData.NominationGoodsData[i].OrderNum6Digits);
        obj.ItemCode = this.nullTOEmpty(serverData.NominationGoodsData[i].ItemCode);
        obj.OrderGoodsFlg = this.nullTOEmpty(this.kymw1404Component.cmb_OrderGoodsFlg.selectedCodeValue);

        // 作業用配列に追加
        nominationList.push(obj);
      }
    }

    // 検索フラグを初期化
    this.processDiv = 1;

    // 作業用配列を現在の配列に書き換え
    this.nominationGoodsArray = nominationList;
    this.listCnt = this.nominationGoodsArray.length;
    this.kymw1404Component.cmb_SellAreaName.nativeElement.focus();

    // フィルタ設定を読み込むためデータをそのままitemsSourceに入れ、refreshする
    this.kymw1404Component.dtg_NominationGoodsList.itemsSource = this.nominationGoodsArray;
    this.kymw1404Component.dtg_NominationGoodsList.refresh();
    // フィルタ状態を設定
    this.kymw1404Component.flr_NominationGoodsList.filterDefinition = this.kymw1404Component.kymw1404Model.filterStatus;
    // ソート状態を設定
    if (!PlessViewUtilsSub.isEmpty(this.sortStatus) && !PlessViewUtilsSub.isEmptyArray(this.sortStatus)) {
      this.kymw1404Component.dtg_NominationGoodsList.collectionView.sortDescriptions.push(new wjcCore.SortDescription(this.sortStatus[0].property, this.sortStatus[0].ascending));
    }
  }

  /**
   * 検索結果をクリア
   */
  public clear(): void {

    // 一覧表示を初期化
    this.nominationGoodsArray = null;
    this.kymw1404Component.setColorPattern();

  }

  /**
   * NULLデータを表示用に空白に変換
   */
  private nullTOEmpty(obj: any): string {
    if (obj == null) {
      return '';
    } else {
      return obj;
    }
  }
}
